// ESM re-export of the CJS-tested commit-banner helper, so the page can import it
// while Jest unit-tests the .cjs sibling directly (no ESM transform under Jest).
export { commitBannerText } from './voice-memo-commit-banner.cjs';
